<template lang="pug">
.content
  section.container-fluid.p-t-20
    a-breadcrumb(separator=">")
      a-breadcrumb-item
        router-link(to="/") 控制台
      a-breadcrumb-item
        router-link(to="/case") 案例管理
      a-breadcrumb-item {{ data.id ? '编辑案例' : '新增案例' }}
      
    .m-t-15.m-b-20
      h1.section-title.inline {{ data.id ? '编辑案例' : '新增案例' }}
      a-button.m-l-15(size="small" @click="() => { this.$router.push({ name: 'Case Management' }) }") 案例管理

  .container-fluid.clearfix(style="padding-right: 15px; margin-right: 335px;")
    a-form-model.case-formz(ref="form" :model="data")
      //- :label-col="{ xs: { span: 5 }, sm: { span: 5 }, md: { span: 3 }, lg: { span: 3 }, xl: { span: 2 }, xxl: { span: 2 } }"
      //- :wrapper-col="{ span: 18 }")

      //- a-form-model-item(:wrapper-col="{ xs: { span: 18 }, sm: { span: 18 }, md: { span: 18, offset: 3 }, lg: { span: 18, offset: 3 }, xl: { span: 18, offset: 2 }, xxl: { span: 18, offset: 2 } }")
      
      .inner-content-right
        .editor-wrap
          a-card.m-b-15(size="small" :bordered="false" :bodyStyle="{ padding: 0 }")
            a-input(size="large" v-model="data.title")
            
          a-card.m-b-15(size="small" :bodyStyle="{ padding: 0 }")
            vc-tinymce(v-model="data.content")
          
        a-card.m-b-15(size="small" title="背景")
          small(slot="extra") {{ upload_options.thumbnail.tip }}
          vc-uploader(:data="data.thumbnail" :options="upload_options.thumbnail" @success="onSuccess")
            
          //- pre {{ data }}

      .secondary-sidebar-right
        a-card.m-b-15(size="small" title="发布")
          a-form-model-item.m-b-0(label="排 序:"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol")
            a-input-number(:min="0" v-model="data.menu_order")
            
          a-button.submit(type="primary" block @click="submit") 提交
        
        a-card.m-b-15(size="small" title="标志")
          small(slot="extra") {{ upload_options.logo.tip }}
          vc-uploader(:data="data.logo" :options="upload_options.logo" @success="onSuccess")

        //- pre(style="font-size:10px;") {{ case_tag }}
        //- pre(style="font-size:10px;") {{ tag_ids }}
</template>

<script>
//- import { mapState } from 'vuex'

import vcUploader from '@/components/vcUploader'
import vcTinyMCE from '@/components/vcTinyMCE'

export default {
  name: 'CaseForm',
  components: {
    'vc-uploader': vcUploader,
    'vc-tinymce': vcTinyMCE
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    rules: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      tag_dis: false,
      tag_loading: false,
      
      activeKey: [],   // collapse

      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      },

      users: [],
      
      upload_options: {
        logo: {
          accept: ['.jpg', '.gif', '.png'],
          multiple: false,
          app: 'admin',
          module: 'case',
          key: 'logo',
          tip: '尺寸大小建议 250 × 110 像素'
        },
        thumbnail: {
          accept: ['.jpg', '.gif', 'image/webp'],
          multiple: false,
          app: 'admin',
          module: 'case',
          key: 'thumbnail',
          tip: '尺寸大小建议 1920 × 1000 像素'
        }
      }
    }
  },
  computed: {
  },
  methods: {    
    //- 创建标签
    async createTag() {
    },
    //- 获取父级
    async getParent() {},
    //- 获取分类标签
    async getTaxonomies(taxonomy) {
      this[taxonomy] = await this.$http.get(taxonomy, {
        params: {
          limit: -1
        }
      });
    },
    //- 获取用户
    async getUsers() {
      this.users = await this.$http.get('user', {
        params: {
          limit: -1
        }
      });
    },

    async submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return this.$message.error('提交失败');
        try {
          const method = this.data.id ? 'put' : 'post';
          const url = this.data.id ? `case/${this.data.id}`: 'case';
          await this.$http[method](url, this.data);
          this.$refs.form.resetFields();
          this.$message.success('提交成功');
        } catch(err) {
          this.loading = false;
          this.$message.error(err.message);
        }
      })
    },

    /*********************************************************
     * @description 上传组件回调 删除/上传成功
     *********************************************************/
    // 删除/上传成功
    onSuccess(key, res) {
      this.data[key] = res;
    },
  },
  created() {
    //- this.getParent();
    this.getUsers();
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.secondary-sidebar-right {
  float: left;
  width: 310px;
  margin-right: -310px;
}
.inner-content-right {
  float: left;
  width: 100%;
  margin-right: 15px;
}

.case-form {
  .ant-divider { margin: 16px 0;}
  .ant-form-item {
    margin: 12px 0;
  }
  .ant-card {
    .ant-form-item {
      margin: 6px 0;
      label { font-size: 12px;}
    }
    .ant-form-item-label { line-height: 35px;}
    .ant-form-item-control { line-height: 36px;}
    .ant-input,
    .ant-input-number {
      height: 30px;
    }
  }
}
</style>